import type { NavigationGuard, RouteConfig, } from 'vue-router';

function loadNavigationGuard(name: keyof typeof import('./route-guards')): NavigationGuard {
	return (to, from, next) => {
		import('./route-guards').then((a) => {
			a[name](to, from, next);
		});
	};
}

export const PayBillRoutes: RouteConfig[] = [
	{
		path: '/pay-bill',
		component: () => import(/* webpackChunkName: "chunk-your-account-pay-bill" */'./pages/master.vue').then((m) => m.default),
		beforeEnter: loadNavigationGuard('LoadPaymentDetails'),
		children: [
			{ path: `choose-amount`, name: `PayBillChooseAmount`, component: () => import(/* webpackChunkName: "chunk-your-account-pay-bill" */'./pages/choose-amount.vue').then((m) => m.default), beforeEnter: loadNavigationGuard('RequiresUserPaymentDetails'), },
			{ path: `payment`, component: () => import(/* webpackChunkName: "chunk-your-account-pay-bill" */'./pages/payment-detail.vue').then((m) => m.default), beforeEnter: loadNavigationGuard('RequiresUserPaymentDetails'), },
			{ path: `success`, component: () => import(/* webpackChunkName: "chunk-your-account-pay-bill" */'./pages/payment-success.vue').then((m) => m.default), },
			{ path: `error/payment`, component: () => import(/* webpackChunkName: "chunk-your-account-pay-bill" */'./pages/payment-failure.vue').then((m) => m.default), },
			{ path: `error/system`, component: () => import(/* webpackChunkName: "chunk-your-account-pay-bill" */'./pages/system-failure.vue').then((m) => m.default), },
			{ path: `pending`, component: () => import(/* webpackChunkName: "chunk-your-account-pay-bill" */'./pages/payment-pending.vue').then((m) => m.default), },
			{ path: '', redirect: 'choose-amount', name: 'PayBill', },
		],
	},
];
